// extracted by mini-css-extract-plugin
export default {"input":"M9-z","button":"N9-z","selected":"O9-z","unavailable":"P9-z","oos":"Q9-z","image":"R9-z","paperCutDisabledOverlay":"S9-z"};